import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import React, { useState } from "react"
import * as style from "./style.module.css"
import json from "/src/siteData.json"
import { getPathFromTemplateType } from "/src/utils/getPathFromTemplateType"

import { useScrollbarWidthSizeFunc } from "../../utils/globalFunctions"

// import Logo from "../../images/common/logo.png";

const siteMetaData = json.siteMetadata
const logoUri = json.header.logoUri

const Component = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <header className={style.container}>
      <div className={style.logo}>
        <Link to="/">
          <img
            src={logoUri}
            alt={siteMetaData.title}
            width={235}
            height={50}
            style={{ objectFit: "contain" }}
          />
          {/* <img src={Logo}
            width={235}
            height={50}
            alt="株式会社さちなび"
            style={{ objectFit: "contain" }}  
          /> */}
        </Link>
      </div>
      <button
        className={`${style.menu} is-sp`}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        {!isOpen ? (
          <StaticImage
            src="../../images/icon/menu_open.svg"
            loading="eager"
            formats={["auto", "webp", "avif"]}
            alt="開く"
          />
        ) : (
          <StaticImage
            src="../../images/icon/menu_close.svg"
            loading="eager"
            formats={["auto", "webp", "avif"]}
            alt="閉じる"
          />
        )}
      </button>
      <div className={`${style.nav} ${isOpen ? style.nav_open : ""}`}>
        <nav className={style.nav_container}>
          <ul className={style.nav_list}>
            <li className={style.nav_item}>
              <Link to={"/"}>HOME</Link>
            </li>
            <li className={style.nav_item}>
              <Link to={"/articles/p/1"}>BLOG</Link>
            </li>
            <li className={style.nav_item}>
              <Link to={getPathFromTemplateType(2)}>会社概要</Link>
            </li>
            <li className={style.nav_item}>
              <Link to={getPathFromTemplateType(3)}>施設紹介</Link>
            </li>
            <li className={style.nav_item}>
              <Link to={"/recruit"}>採用情報</Link>
            </li>
            <li className={`${style.nav_item} ${style.nav_item_emphasis}`}>
              <Link to={getPathFromTemplateType(6)}>お問い合わせ</Link>
            </li>

          </ul>
        </nav>
        <small className={`${style.nav_copyright} is-sp`}>
          &copy; {siteMetaData.title}
        </small>
      </div>
    </header>
  )
}

export default Component
